export const VIDEO_CONFERENCE_KINDS = [
  'lc_meet_conference',
  'zoom_conference',
  'google_conference',
  'ms_teams_conference',
] as const

export const CONFERENCE_OR_BOOKER_KINDS = [
  ...VIDEO_CONFERENCE_KINDS,
  'booker',
] as const

export const STAFF_DEFAULT_MEETING_LOCATION_VALUE: Record<string, string> = {
  zoom_conference: 'true',
  ms_teams_conference: 'true',
  custom: 'false',
  google_conference: 'meet',
  lc_meet_conference: 'lc_meet',
  inbound_call: 'phone',
  physical: 'address',
}

export function isVideoConferenceKind(kind: string): boolean {
  return (VIDEO_CONFERENCE_KINDS as readonly string[]).includes(kind)
}

export function isConferenceOrBookerKind(kind: string): boolean {
  return (CONFERENCE_OR_BOOKER_KINDS as readonly string[]).includes(kind)
}

export function meetingKindFromStaffDefault(
  selectedIsZoomAdded: string | undefined
): string {
  if (selectedIsZoomAdded === 'true') {
    return 'zoom_conference'
  }
  if (selectedIsZoomAdded === 'meet') {
    return 'google_conference'
  }
  if (selectedIsZoomAdded === 'lc_meet') {
    return 'lc_meet_conference'
  }
  if (selectedIsZoomAdded === 'ms_teams') {
    return 'ms_teams_conference'
  }
  if (selectedIsZoomAdded === 'phone') {
    return 'inbound_call'
  }
  if (selectedIsZoomAdded === 'address') {
    return 'physical'
  }
  return 'custom'
}
